import * as React from 'react';
import { WActionButton } from '../../core/elements/WActionButton';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { DateneingabePendelnKampagne } from './DateneingabePendelnKampagne';

export interface DateneingabePendelnKampagneWrapperProps {
    rowTid: number;
    data: any;
    layout?: string;
    useExternOpenButton?: boolean;
    onClose?: () => void;
}

export interface DateneingabePendelnKampagneWrapperState {
    showDialog: boolean;
}

export class DateneingabePendelnKampagneWrapper extends React.Component<DateneingabePendelnKampagneWrapperProps, DateneingabePendelnKampagneWrapperState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showDialog: this.props.useExternOpenButton && !!this.props.rowTid
        };
        this.onClose = this.onClose.bind(this);
    }

    componentDidMount(): void {

    }

    render(): JSX.Element {
        const styleProps = this.props.layout === 'sidebysideComplexGreen' ? { height: 20, margin: 0, width: 'calc(100% - 8px)' } : undefined;
        return <div>
            {!this.props.useExternOpenButton && this.props.rowTid > 0 && <WActionButton
                styleProps={styleProps}
                label='Kampagne öffnen'
                insideText='Kampagne öffnen'
                key='btn_show'
                action='show'
                onAction={() => this.setState({ showDialog: true })}
            />}
            {this.state.showDialog && this.renderDialog()}
        </div>;
    }

    renderDialog() {
        return <div>
            <DialogWrapper2
                width={-1}
                onAfterClose={this.onClose}
            >
                <div style={{ marginTop: 10, width: 880 }}>
                    <DateneingabePendelnKampagne
                        rowTid={this.props.rowTid}
                        data={this.props.data}
                        onClose={this.onClose}
                    />
                    <div style={{ textAlign: 'right', marginRight: 30, marginBottom: 15 }}>
                        {this.renderCloseButton()}
                    </div>
                </div>
            </DialogWrapper2>
        </div>;
    }

    renderCloseButton(): JSX.Element {
        return (
            <WActionButton
                label='Schließen'
                insideText='Schließen'
                key='btn_close'
                action='delete'
                onAction={this.onClose}
            />
        );
    }

    onClose() {
        this.setState({ showDialog: false });
        if (typeof this.props.onClose === 'function') {
            this.props.onClose();
        }
    }
}
